import ChannelContext from '@jetshop/core/components/ChannelContext';
import React, { useContext, useEffect } from 'react';
import { styled } from 'linaria/react';
import { useScript } from '../../hooks/useScript';
import t from '@jetshop/intl';

const ProductReviewWrapper = styled('div')`
  margin: auto;
  .lipscore-review-list-footer {
    a {
      display: none;
    }
  }
  .no-reviews {
    display: none;
  }
  [data-ls-product-votes='0'] + .no-reviews {
    display: block;
  }

  .lipscore-review-info-wrapper {
    .lipscore-review-rating-stars-wrapper {
      .lipscore-rating-star {
        /* fill: black; */
        height: 12px;
        width: 12px;
      }
    }
  }

  .lipscore-review-purchase {
    color: #666666;
    .lipscore-review-purchase-icon {
      .lipscore-review-purchase-icon-badge {
        filter: brightness(0%) !important;

        .lipscore-visually-hidden {
        }
      }
    }
  }
`;

export const LipscoreProductReview = ({ product }) => {
  const { selectedChannel } = useContext(ChannelContext);
  const apiKey = 'bea38eb1dfc86107b7f011c6';
  const language = selectedChannel?.country?.code?.toLowerCase();
  const currency = selectedChannel?.currency?.name;
  const brand = product?.subName;
  const path = product?.primaryRoute?.path;
  const [loaded, error] = useScript(
    '//static.lipscore.com/assets/' + language + '/lipscore-v1.js'
  );

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (loaded) {
        if (window.lipscore) {
          if (!window.lipscore.isInitialized()) {
            window.lipscoreInit = () => {
              window.lipscore.init({
                apiKey: apiKey,
              });
            };
            window.lipscore.apiKey = apiKey;
          }
          window.lipscore.initWidgets();
        }
      }
    }
  }, [loaded]);

  if (!loaded || error) return null;

  return (
    <ProductReviewWrapper className='hideInPrint'>
      <div
        id="lipscore-review-list"
        ls-product-name={product?.name}
        ls-brand={brand}
        ls-product-id={product?.id}
        ls-product-url={selectedChannel?.url + path}
        ls-description={product.shortDescription}
        ls-price={product?.price?.incVat}
        ls-price-currency={currency}
      />
      <p className={'no-reviews'}>{t('No reviews yet')}</p>
    </ProductReviewWrapper>
  );
};
